import type { ReactNode } from "react";

/**
 * Jarvis's only visual home: violet, bounded, always labeled — never colored
 * like verified fact. `onDark` switches to a legible variant for use inside
 * the navy hero card (Today's "Start here" situation) — same violet hue,
 * lightened for contrast against RISE Navy rather than against a white card.
 */
export function JarvisPanel({ label = "Jarvis", onDark = false, children }: { label?: string; onDark?: boolean; children: ReactNode }) {
  return (
    <div
      className={`flex gap-2.5 rounded-md border p-3.5 ${onDark ? "border-white/15 bg-white/10" : "border-ai/25 bg-ai/10"}`}
      role="note"
      aria-label={`${label} assessment (not verified fact)`}
    >
      <span className={`mt-0.5 flex-none ${onDark ? "text-[#C9A9FA]" : "text-ai"}`} aria-hidden="true">
        ✦
      </span>
      <div className="min-w-0 text-[13px] leading-5">
        <p className={`mb-0.5 font-mono text-[10px] font-semibold uppercase tracking-wide ${onDark ? "text-[#C9A9FA]" : "text-ai"}`}>{label}</p>
        <div className={onDark ? "text-white/90" : "text-[#4C3283]"}>{children}</div>
      </div>
    </div>
  );
}
